import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Diagnose from "./pages/Diagnose";
import ObdLookup from "./pages/ObdLookup";
import History from "./pages/History";
import Guides from "./pages/Guides";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/accedi" element={<Auth />} />
            <Route path="/diagnosi" element={<ProtectedRoute><Diagnose /></ProtectedRoute>} />
            <Route path="/codici-obd" element={<ObdLookup />} />
            <Route path="/guide" element={<Guides />} />
            <Route path="/storico" element={<ProtectedRoute><History /></ProtectedRoute>} />
          </Routes>
          <Toaster theme="dark" position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
